<template>
  <div class="container">
    <div
      id="loadingmessage"
      style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
      v-if="loading"
    >
      <p style="position: absolute; color: White; top: 40%; left: 40%;">
        <img src="../assets/animation.gif" />
      </p>
    </div>
    <div class="col-md-12">
      <h5 class="card-title">Snake Search</h5>
    </div>
    <div
      class="row"
      v-cloak
      style="border: 1px solid #dedede;padding-top:10px;background-color: whitesmoke;"
    >
      <div class="col-md-1"></div>
      <div class="col-md-3">
        <div class="form-group label-floating">
          <label class="control-label">Common Name</label>
          <input type="text" class="form-control" v-model="name" required />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group label-floating">
          <label class="control-label">Distribution</label>
          <v-select multiple v-model="states" :options="option"></v-select>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group label-floating">
          <label class="control-label">Venom Type</label>
          <v-select multiple v-model="venomType" :options="venum"></v-select>
        </div>
      </div>
      <div class="col-md-1">
        <div class="form-group label-floating" style="padding-top:5px;">
          <label class="control-label"></label>
          <button id="btns" class="btn btn-success" @click="resetData">Reset</button>
        </div>
      </div>
    </div>
    <div class="loader" v-if="load == true">
      <div class="bar"></div>
    </div>
    <div class="row" v-if="show == 0">
      <div
        class="col-md-3"
        v-for="mainImageSrc in items"
        v-bind:key="mainImageSrc.name"
        style="padding-top:25px;"
      >
        <div class="card">
          <router-link :to="'/snakedetails/' + mainImageSrc.name">
            <img
              class="card-img-top"
              v-bind:src="'https://api.indiansnakes.org/u/'+mainImageSrc.photographs[0].url"
              alt="Card image cap"
            />
          </router-link>
          <div class="card-body">
            <h5 class="card-title" style="text-transform:capitalize;">{{mainImageSrc.name}}</h5>
            <h6>
              <i>({{mainImageSrc.scientificName}})</i>
            </h6>
            <p class="card-text" v-if="mainImageSrc.venomType != ''">
              <a
                v-if="mainImageSrc.venomType == 'Highly Venomous' "
                style="color:red!important;"
              >{{mainImageSrc.venomType}}</a>
              <a
                v-if="mainImageSrc.venomType == 'Mildly Venomous' "
                style="color:orange!important;"
              >{{mainImageSrc.venomType}}</a>
              <a
                v-if="mainImageSrc.venomType == 'Non Venomous' "
                style="color:green!important;"
              >{{mainImageSrc.venomType}}</a>
            </p>
            <p class="card-text" v-else>NA</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div
        class="col-md-3"
        v-for="mainImageSrc in item"
        v-bind:key="mainImageSrc.name"
        style="padding-top:25px;"
      >
        <div class="card">
          <router-link :to="'/snakedetails/' + mainImageSrc.name">
            <img
              class="card-img-top"
              v-bind:src="'https://api.indiansnakes.org/u/'+mainImageSrc.photographs[0].url"
              alt="Card image cap"
            />
          </router-link>
          <div class="card-body">
            <h5 class="card-title" style="text-transform:capitalize;">{{mainImageSrc.name}}</h5>
            <h6>
              <i>({{mainImageSrc.scientificName}})</i>
            </h6>
            <p class="card-text" v-if="mainImageSrc.venomType != ''">
              <a
                v-if="mainImageSrc.venomType == 'Highly Venomous' "
                style="color:red!important;"
              >{{mainImageSrc.venomType}}</a>
              <a
                v-if="mainImageSrc.venomType == 'Mildly Venomous' "
                style="color:orange!important;"
              >{{mainImageSrc.venomType}}</a>
              <a
                v-if="mainImageSrc.venomType == 'Non Venomous' "
                style="color:green!important;"
              >{{mainImageSrc.venomType}}</a>
            </p>
            <p class="card-text" v-else>NA</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
export default {
  name: "Images",
  data() {
    return {
      loading: false,
      load: false,
      images: [],
      items: [],
      item: [],
      itemssec: [],
      itemsthr: [],
      name: "",
      state: "",
      venum: ["Highly Venomous", "Mildly Venomous", "Non Venomous"],

      option: [
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chhattisgarh",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jammu and Kashmir",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
        "Andaman and Nicobar",
        "Chandigarh",
        "Dadra and Nagar Haveli",
        "Daman and Diu",
        "Lakshadweep",
        "Delhi",
        "Puducherry"
      ],
      states: [],
      show: 0,
      interval: null,
      venomType: ""
    };
  },
  watch: {
    name: function() {
      if (this.name != "") this.searchSnake();
    },
    states: function() {
      if (this.states.length != 0) this.searchSnake();
    },
    venomType: function() {
      if (this.venomType != "") this.searchSnake();
    }
  },
  methods: {
    resetData: function() {
      (this.item = []),
        (this.name = ""),
        (this.states = []),
        (this.venomType = "");
      this.show = 0;
      this.loadData();
    },
    searchSnake: function() {
      this.show = 1;
      this.load = true;
      var data = {};
      if (this.name != "") data["name"] = this.name;
      if (this.states != "") data["state"] = this.states;
      if (this.venomType.length > 0) {
        for (var i = 0; i < this.venomType.length; i++) {
          if (this.venomType[i] == "Highly Venomous") {
            data["highlyvenomous"] = "true";
          }
          if (this.venomType[i] == "Mildly Venomous") {
            data["mildlyvenomous"] = "true";
          }
          if (this.venomType[i] == "Non Venomous") {
            data["nonvenomous"] = "true";
          }
        }
      }
      axios({
        url: "https://api.indiansnakes.org/guestsearch/",
        method: "POST",
        data: data
      })
        .then(response => {
          this.item = response.data.data;
          this.load = false;
        })
        .catch(e => {
          this.errors.push(e);
        });
    },
    loadData: function() {
      this.loading = true;
      axios({
        url: "https://api.indiansnakes.org/snake/randomlist/",
        method: "GET"
      })
        .then(response => {
          this.items = response.data.data;
          this.loading = false;
        })
        .catch(e => {
          this.errors.push(e);
        });
    },
    loadData1: function() {
      axios({
        url: "https://api.indiansnakes.org/snake/randomlist/",
        method: "GET"
      })
        .then(response => {
          this.items = response.data.data;
        })
        .catch(e => {
          this.errors.push(e);
        });
    }
  },
  mounted: function() {
    this.loadData();
    this.interval = setInterval(
      function() {
        this.loadData1();
      }.bind(this),
      20000
    );
  }
};
</script>
<style scoped>
@keyframes loader-animation {
  0% {
    width: 0%;
  }
  49% {
    width: 100%;
    left: 0%;
  }
  50% {
    left: 100%;
    width: 0;
  }
  100% {
    left: 0%;
    width: 100%;
  }
}
.loader {
  height: 5px;
  width: 100%;
}
.loader .bar {
  position: absolute;
  height: 5px;
  background-color: dodgerblue;
  animation-name: loader-animation;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}
a:hover {
  color: #6c757d;
  text-decoration: none !important;
}
a {
  color: #010101;
}
</style>